module.exports = __webpack_public_path__ + "media/audio5.effdb176.mp3";